import React from "react";
import vfxImage from "../../assets/images/vfx.jpg";

const VisualEffectMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src={vfxImage} alt="Visual Effects" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master the Art of Visual Effects (VFX) with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy, one of the best film schools, offers a professional <strong>VFX Course</strong> designed for aspiring visual effects artists. Whether you're looking for <strong>VFX courses in Jaipur</strong> or want to <strong>learn VFX Course in Jaipur</strong> with hands-on industry training, this program covers everything from fundamental techniques to advanced VFX production workflows. Gain practical experience with industry-standard software and mentorship from top professionals to build a successful career in the visual effects industry.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">Course Overview</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Level: Beginner to Advanced</li>
              <li>Duration: 12-24 weeks</li>
              <li>Certification: Certificate in Visual Effects</li>
              <li>Career Paths: VFX Artist, 3D Modeler, Animator, Compositor, VFX Supervisor</li>
            </ul>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F] mt-4">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Core principles of <strong>VFX</strong> and their applications in film and TV</li>
              <li>Mastering industry-leading software like Maya, 3ds Max, Nuke, and After Effects</li>
              <li>Techniques for <strong>3D modeling, texturing, compositing, and animation</strong></li>
              <li>Advanced <strong>matchmoving, tracking, and VFX compositing</strong> workflows</li>
              <li>Working on real-world projects to gain industry experience</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 1: Introduction to VFX</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Overview of the VFX industry</li>
              <li>History and evolution of VFX</li>
              <li>Role of a VFX artist in film and TV production</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 2: 3D Modeling and Texturing</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to 3D modeling software (Maya, 3ds Max)</li>
              <li>Texturing and shading techniques</li>
              <li>UV unwrapping and mapping</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 3: Lighting and Shading</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Fundamentals of lighting in VFX</li>
              <li>Shading and material creation</li>
              <li>Lighting for different environments</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 4: Animation and Dynamics</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Keyframe animation and motion control</li>
              <li>Physics-based simulations (rigid body, soft body, fluids)</li>
              <li>Particle effects and special effects animation</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 5: Compositing and Visual Effects</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Hands-on training with Nuke and After Effects</li>
              <li>Green screen removal (chroma keying)</li>
              <li>Color grading and correction</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 6: Matchmoving and Tracking</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Matchmoving software (PFTrack, Syntheyes)</li>
              <li>3D camera tracking and object tracking</li>
              <li>Seamless integration of CG elements with live footage</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 7: Rotoscoping and Paint</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Rotoscoping techniques and tools</li>
              <li>Digital painting and matte painting</li>
              <li>Image manipulation for VFX</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 8: Advanced VFX Techniques</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>High-end compositing techniques</li>
              <li>Advanced 3D animation and dynamics</li>
              <li>Photorealistic rendering and final output</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 9: VFX for Film and TV</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Understanding VFX pipelines in film and television production</li>
              <li>Collaborating with directors, producers, and cinematographers</li>
              <li>Delivering final VFX shots for various platforms</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Module 10: Career Development and Industry Insights</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Industry trends and advancements in VFX</li>
              <li>Career opportunities in film, TV, and gaming industries</li>
              <li>Building a portfolio and networking for job placements</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from the Best</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Faculty</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Experienced VFX artists and supervisors</li>
                <li>Industry professionals from top VFX studios</li>
              </ul>
              <h3 className="uppercase tracking-wide text-xl font-bold mb-3 mt-5 text-[#A14D1F]">Guest Lectures</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Renowned VFX specialists, animators, and compositors</li>
                <li>Industry leaders in film, TV, and gaming VFX</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Practical Experience & Software Training</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Hands-on VFX courses in Jaipur with real-world projects</li>
                <li>Work on films, advertisements, and gaming projects</li>
                <li>Collaborative projects with cinematographers, editors, and directors</li>
              </ul>
              <h3 className="uppercase tracking-wide text-xl font-bold mb-3 mt-5 text-[#A14D1F]">Software Training</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Autodesk Maya</li>
                <li>3ds Max</li>
                <li>Nuke</li>
                <li>Adobe After Effects</li>
                <li>PFTrack</li>
                <li>Syntheyes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Certification & Career Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Earn a <strong>Certificate in Visual Effects</strong> upon completion</li>
              <li>Career paths include VFX Artist, 3D Modeler, Animator, Compositor, VFX Supervisor</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Visual Effects Society (VES)</li>
              <li>International Visual Effects Association (IVEA)</li>
              <li>Motion Picture Association of America (MPAA)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Project-Based Learning</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Work on industry-level VFX projects</li>
              <li>Collaborate with film students on short films and animations</li>
              <li>Receive mentorship and feedback from industry professionals</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold  text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Develop essential VFX techniques for film and TV</li>
              <li>Master industry-standard software and workflows</li>
              <li>Build a professional portfolio with real-world projects</li>
              <li>Gain hands-on experience and industry exposure</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Take the Next Step in Your VFX Career!</h3>
          <p className="mb-6 text-gray-700">Enroll in the VFX Course at Sunrising Cinevision Academy and gain the expertise needed to succeed in the competitive world of visual effects.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default VisualEffectMain;
